import "styled-components";
import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  colors: {
    red: "hsl(357, 92%, 47%)",
    green: "hsl(151, 100%, 36%)",
    darkgray: "hsl(240, 6%, 28%)",
    // lightgray: "hsl(0, 0%, 97%)",
    lightgray: "hsla(0, 0%, 0%, 0.05)",
    white: "hsl(0, 0%, 100%)",
    black: "hsl(0, 0%, 0%)",
    blue: "hsl(199, 92%, 56%)",
    warning: "hsl(36, 100%, 57%)",
    breadcrumb: "hsl(0, 0%, 77%)",
    transparent: "transparent",
  },
};

declare module "styled-components" {
  export interface DefaultTheme {
    colors: {
      red: string;
      green: string;
      darkgray: string;
      lightgray: string;
      white: string;
      black: string;
      blue: string;
      warning: string;
      transparent: string;
      breadcrumb: string;
    };
  }
}
